(function () {
	function swiperDestroy() {
		document.querySelectorAll(".js-media-list").forEach((elem) => {
			if (elem.swiper) {
				elem.swiper.destroy(true, true);
			}
		});
		document.querySelectorAll(".js-media-sublist").forEach((elem) => {
			if (elem.swiper) {
				elem.swiper.destroy(true, true);
			}
		});
	}

	function swiperInit() {
		swiperDestroy();
		subSliderInit(true);
		sliderInit(true);
	}

	window.swiperInit = swiperInit;
	window.swiperDestroy = swiperDestroy;

	document.addEventListener("shopify:section:load", function (e) {
		swiperInit();
	});

	swiperInit();
})();